<template>
  <div>
    <div>
      <v-container>
        <notify-menu></notify-menu>
        <v-layout>
          <v-flex>
            <div>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <div class="form-control" style="position: relative">
                        <div class="labelinputontop">Start date</div>
                        <DatePickerWithoutButton
                          v-model="selectedDate.start"
                          @change="onChangeDate"
                        >
                          <input readonly :value="DateFormat(selectedDate.start)" type="text" />
                        </DatePickerWithoutButton>
                      </div>
                    </v-flex>
                    <v-flex xs6 class="pl-2">
                      <div class="form-control" style="position: relative">
                        <div class="labelinputontop">End date</div>
                        <DatePickerWithoutButton v-model="selectedDate.end" @change="onChangeDate">
                          <input readonly :value="DateFormat(selectedDate.end)" type="text" />
                        </DatePickerWithoutButton>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex xs7>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div class="text-xs-right">
                        <!-- <exportxlsx></exportxlsx> -->
                        <span>
                          <v-btn
                            :loading="exportloading"
                            outline
                            color="grey"
                            class="ma-0 mb-0"
                            @click="exportData"
                          >
                            <em class="fas fa-file-export mr-1" /> {{ $t('export') }}
                          </v-btn>
                        </span>
                        <TicketEdit
                          :type="'add'"
                          :loading="loading"
                          @addTicket="onAddTicket"
                        ></TicketEdit>
                        <v-btn
                          ripple
                          color="primary"
                          outline
                          @click="ticket2getticket(limit, offset)"
                        >
                          <em class="fa fa-refresh" />
                          <span class="pl-2">Refresh</span>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
            <div>
              <v-layout row wrap class="mb-0 pl-2">
                <v-flex xs6>
                  <div>
                    <div class="form-control">
                      <div style="position: relative">
                        <input
                          v-model="filter.search"
                          class="mb-0"
                          placeholder="Search"
                          type="text"
                          @keyup.enter="onSearch"
                        />
                        <v-btn
                          :loading="loading"
                          style="position: absolute; right: 5px; top: 5px"
                          class="ma-0"
                          icon
                          @click="onSearch"
                          ><v-icon color="primary">search</v-icon></v-btn
                        >
                      </div>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs6 class="pt-0">
                  <div class="text-xs-right">
                    <v-pagination
                      v-model="page"
                      :length="pagelength"
                      :total-visible="7"
                      @input="changepage"
                    ></v-pagination>
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <v-layout row wrap class="mb-0">
              <v-flex xs3 class="pa-2 mt-0">
                <div class="pa-2" style="background-color: #eee; border-radius: 8px">
                  <div>
                    <div>
                      Sort by
                      <DropdownMenu
                        v-model="filter.sortBy"
                        :outtericon="true"
                        :options="optionsSort"
                        :text-value="'value'"
                        :text-label="'label'"
                        @change="onSearch"
                      >
                        <span style="font-weight: bold">{{ sortByLabel }}</span>
                      </DropdownMenu>
                    </div>
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div>Priority</div>
                  <div>
                    <multiselect
                      v-model="filter.priority"
                      tag-placeholder="Add this as new tag"
                      placeholder="Priority"
                      :searchable="false"
                      :options="optionsPriority"
                      :multiple="true"
                      :taggable="true"
                      :show-labels="false"
                      @input="onSearch"
                    ></multiselect>
                  </div>

                  <div class="mt-3">Status</div>
                  <div>
                    <multiselect
                      v-model="filter.status"
                      tag-placeholder="Add this as new tag"
                      placeholder="Status"
                      :searchable="false"
                      :options="optionsStatus"
                      :multiple="true"
                      :taggable="true"
                      :show-labels="false"
                      @input="onSearch"
                    ></multiselect>
                  </div>
                  <div class="mt-3">Tags</div>
                  <div>
                    <multiselect
                      v-model="filter.tags"
                      tag-placeholder="Add this as new tag"
                      placeholder="Tags"
                      :options="tags"
                      :multiple="true"
                      :taggable="true"
                      :show-labels="false"
                      @input="onSearch"
                      @tag="addTag"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
              <v-flex xs9 class="mt-2">
                <div>
                  <div
                    class="my-0 pa-3"
                    style="background-color: #eee; border-radius: 10px; min-height: 400px"
                  >
                    <div v-if="loading">
                      <scale-loader class="mt-5" :loading="true" :color="'grey'"></scale-loader>
                    </div>
                    <div v-else-if="!tickets.length">
                      <div class="text-xs-center pt-5" style="font-size: 25px">
                        <em style="font-size: 50px" class="far fa-folder-open" />
                        <br />
                        ไม่พบข้อมูล
                      </div>
                    </div>
                    <div v-else-if="!$store.state.loadingAgentGroups">
                      <div v-for="(item, k) in tickets" :key="item.id" class="mb-2">
                        <TicketItem :ticket.sync="tickets[k]" @ontransfer="onSearch"></TicketItem>
                      </div>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import TicketItem from './TicketItem.vue'
import notifyMenu from './notifyMenu.vue'
import TicketEdit from './TicketEdit.vue'
import Multiselect from 'vue-multiselect'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import ticketApi from '@/api/ticket'
import * as XLSX from 'xlsx'

import { mapGetters } from 'vuex'
export default {
  components: {
    DatePickerWithoutButton,
    exportxlsx,
    DropdownMenu,
    TicketItem,
    notifyMenu,
    Multiselect,
    TicketEdit,
    ScaleLoader
  },
  computed: {
    sortByLabel() {
      return this.optionsSort.find((el) => el.value == this.filter.sortBy).label
    },
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / this.limit)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot'])
  },
  data() {
    return {
      tags: [],
      exportloading: false,
      limit: 10,
      page: 1,
      pagetmp: 1,
      pagetotal: 0,
      offset: 0,
      loading: false,
      showAdd: false,
      optionsPriority: ['Low', 'Medium', 'High'],
      optionsTags: [],
      optionsStatus: ['Pending', 'Answered', 'Cancel', 'Closed'],
      optionsSort: [
        { label: 'Due by time', value: 'duedate' },
        { label: 'Created date', value: 'starttime' },
        { label: 'Priority', value: 'priority' },
        { label: 'Status', value: 'status' }
      ],
      input: {
        search: ''
      },
      filter: {
        search: '',
        sortBy: 'duedate',
        priority: '',
        status: ['Pending', 'Answered'],
        tags: []
      },
      tickets: [],
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
    }
  },
  mounted() {
    this.ticket2getticket(this.limit, this.offset)
    this.getTicketTags()
  },
  methods: {
    formatFilter() {
      var data = {}

      if (this.filter.status) {
        data.status = this.filter.status.join(',').toLowerCase()
      }
      if (this.filter.priority) {
        data.priority = this.filter.priority
      }
      if (this.filter.search) {
        data.search = this.filter.search
      }
      if (this.filter.sortBy) {
        data.sortBy = this.filter.sortBy
      }
      if (this.filter.tags) {
        data.tags = this.filter.tags.join(',').toLowerCase()
      }
      if (this.selectedDate.start) {
        data.startTime = this.selectedDate.start
      }
      if (this.selectedDate.end) {
        data.endTime = this.selectedDate.end
      }
      return data
    },
    async exportData() {
      const vm = this
      const filename = 'ticketlist'

      let json = []

      const filter = this.formatFilter()
      vm.exportloading = true
      let data = {
        pageid: this.selectedBot.pageid,
        ...filter
      }
      try {
        const response = await api.ticket2CommonGetTicket2(data)
        let tickets = []
        if (response.status == 200 && response.data && response.data.data) {
          tickets = response.data.data
        }
        json = tickets.map((el) => {
          var objData
          objData = {
            ID: el.id ? el.id : '-',
            Priority: el.priority ? el.priority : '-'
          }

          if ([...this.$store.state.oceanlifePage].includes(this.selectedBot.pageid)) {
            let extraExport = {
              คะแนนความพึงพอใจ: el.satisfaction_score ? el.satisfaction_score : '-',
              คะแนนในการแนะนำบริการ: el.recommendation_score ? el.recommendation_score : '-'
            }
            Object.assign(objData, extraExport)
          }

          let adminTakeTime =
            el.starttime && el.adminfirstresponsetime
              ? this.durationTime(el.starttime, el.adminfirstresponsetime)
              : '-'

          const channel = this.$store.state.nestlePages.some(
            (page) => page.pageid == this.selectedBot.pageid
          )
            ? this.selectedBot.pagename
            : el.app

          Object.assign(objData, {
            Name: el.first_name ? `${el.first_name}${el.last_name ? ` ${el.last_name}` : ''}` : '-',
            'Latest Email': el.email ? el.email : '-',
            Channel: channel ? channel : '-',
            Subject: el.subject ? el.subject : '-',
            Details: el.details ? el.details : '-',
            Status: el.status ? el.status : '-',
            'Assign To': el.assignadminid ? el.assignadminid : '-',
            // Group: this.groups[el.assigngroupid] ? this.groups[el.assigngroupid].groupname : '-',
            // Subgroup: this.subgroups[el.assignsubgroupid]
            //   ? this.subgroups[el.assignsubgroupid].subgroupname
            //   : '-',
            'Start time (Date)': el.starttime ? moment(el.starttime).format('DD/MM/YYYY') : '-',
            'Start time (Time)': el.starttime ? moment(el.starttime).format('HH:mm') : '-',
            'Admin First Response (Date)': el.adminfirstresponsetime
              ? moment(el.adminfirstresponsetime).format('DD/MM/YYYY')
              : '-',
            'Admin First Response (Time)': el.adminfirstresponsetime
              ? moment(el.adminfirstresponsetime).format('HH:mm')
              : '-',
            'Admin take time': adminTakeTime,
            'End Time': el.endtime ? moment(el.endtime).format('DD/MM/YYYY HH:mm') : '-',
            'Time Closed':
              el.starttime && el.endtime ? this.durationTime(el.starttime, el.endtime) : '-',
            'Due Date': el.duedate ? el.duedate : '-'
          })

          if ([...this.$store.state.toaPaintPage].includes(this.selectedBot.pageid)) {
            if (el.tags) {
              let arrTags = el.tags.split(',') || []
              let tempTags = {}

              arrTags.forEach((tag, index) => {
                let key = `Tag${index + 1}`
                Object.assign(tempTags, { [key]: tag })
              })

              Object.assign(objData, tempTags)
            }
          } else {
            Object.assign(objData, { Tags: el.tags ? el.tags : '-' })
          }

          return objData
        })

        let dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, `${filename}.xlsx`)
      } catch (error) {
        console.error(error)
      } finally {
        vm.exportloading = false
      }
    },
    durationTime(start, end) {
      var startTime = start
      var endTime = end
      var minutes = moment
        .duration(moment(endTime, 'YYYY/MM/DD HH:mm').diff(moment(startTime, 'YYYY/MM/DD HH:mm')))
        .asMinutes()
        .toFixed(2)
      return minutes
    },
    async getTicketTags() {
      try {
        const tags = await ticketApi.getTicketTags({ page_id: this.selectedBot.pageid })
        this.tags = tags.data.data
      } catch (error) {
        console.error(error)
      }
    },
    onChangeDate() {
      this.ticket2getticket(this.limit, this.offset)
    },
    changepage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.ticket2getticket(this.limit, this.offset)
      }
    },
    onAddTicket(ticket) {
      this.onSearch()
    },
    showAddDialog() {
      this.showAdd = true
    },
    addTag(newTag) {
      this.optionsTags.push(newTag)
      this.filter.tags.push(newTag)
    },
    onSearch() {
      this.ticket2getticket(this.limit, this.offset)
    },
    ticket2getticket(limit, offset) {
      var vm = this

      var data = {
        pageid: this.selectedBot.pageid,
        startTime: this.selectedDate.start,
        endTime: this.selectedDate.end,
        limit,
        offset
      }
      Object.entries(this.filter).forEach(([key, value]) => {
        if (value && value.length) {
          if (Array.isArray(value)) {
            Object.assign(data, { [key]: value.join(',').toLowerCase() })
          } else {
            if (key == 'channel' && value == 'all') {
            } else {
              Object.assign(data, { [key]: value.toLowerCase() })
            }
          }
        }
      })
      vm.offset = vm.page * 10 - 10
      if (vm.page != 1) {
        vm.offset + 1
      }
      this.loading = true
      api.ticket2CommonGetTicket(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          this.tickets = response.data
          this.pagetotal = parseInt(response.total)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.labelinputontop {
  position: absolute;
  top: -9px;
  left: 12px;
  font-size: 14px;
  color: #8c8c8c;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toa/management/Management.vue